/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// @ts-ignore
import type { ConfigurationParameters } from '../configuration';
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from '../configuration';
// @ts-ignore
import type { AxiosError, AxiosResponse } from 'axios';
import {
    useQuery,
    UseMutationOptions,
    useMutation,
    UseQueryOptions
    // @ts-ignore
} from 'react-query';
// @ts-ignore
import { useAuthorizationToken, useAuthQueryKey, useApiBasePath } from '../../utils';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { NonEditableRule } from '../models';
// @ts-ignore
import { ObjectSchema } from '../models';
// @ts-ignore
import { ResourceManagerRule } from '../models';
// @ts-ignore
import { ResponseRuleTestDto } from '../models';
// @ts-ignore
import { Rule } from '../models';
// @ts-ignore
import { RuleConstant } from '../models';
// @ts-ignore
import { RuleTestDto } from '../models';
/**
 * RuleEditorControllerApi - axios parameter creator
 * @export
 */
export const RuleEditorControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} context
         * @param {NonEditableRule | ResourceManagerRule | Rule} nonEditableRuleResourceManagerRuleRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRule: async (
            context: string,
            nonEditableRuleResourceManagerRuleRule: NonEditableRule | ResourceManagerRule | Rule,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'context' is not null or undefined
            assertParamExists('createRule', 'context', context);
            // verify required parameter 'nonEditableRuleResourceManagerRuleRule' is not null or undefined
            assertParamExists(
                'createRule',
                'nonEditableRuleResourceManagerRuleRule',
                nonEditableRuleResourceManagerRuleRule
            );
            const localVarPath = `/rule/{context}`.replace(`{${'context'}}`, encodeURIComponent(String(context)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                nonEditableRuleResourceManagerRuleRule,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} context
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRule: async (context: string, name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'context' is not null or undefined
            assertParamExists('deleteRule', 'context', context);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('deleteRule', 'name', name);
            const localVarPath = `/rule/{context}/{name}`
                .replace(`{${'context'}}`, encodeURIComponent(String(context)))
                .replace(`{${'name'}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnumNames: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rule/enums`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjectSchemas: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rule/schemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} context
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRule: async (context: string, name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'context' is not null or undefined
            assertParamExists('getRule', 'context', context);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getRule', 'name', name);
            const localVarPath = `/rule/{context}/{name}`
                .replace(`{${'context'}}`, encodeURIComponent(String(context)))
                .replace(`{${'name'}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleConstants: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rule/constants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} context
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleFile: async (context: string, name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'context' is not null or undefined
            assertParamExists('getRuleFile', 'context', context);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getRuleFile', 'name', name);
            const localVarPath = `/rule/{context}/{name}/file`
                .replace(`{${'context'}}`, encodeURIComponent(String(context)))
                .replace(`{${'name'}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRules: async (context: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'context' is not null or undefined
            assertParamExists('getRules', 'context', context);
            const localVarPath = `/rule/{context}/all`.replace(`{${'context'}}`, encodeURIComponent(String(context)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} context
         * @param {RuleTestDto} ruleTestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testRules: async (
            context: string,
            ruleTestDto: RuleTestDto,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'context' is not null or undefined
            assertParamExists('testRules', 'context', context);
            // verify required parameter 'ruleTestDto' is not null or undefined
            assertParamExists('testRules', 'ruleTestDto', ruleTestDto);
            const localVarPath = `/rule/{context}/test`.replace(`{${'context'}}`, encodeURIComponent(String(context)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(ruleTestDto, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} context
         * @param {NonEditableRule | ResourceManagerRule | Rule} nonEditableRuleResourceManagerRuleRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRule: async (
            context: string,
            nonEditableRuleResourceManagerRuleRule: NonEditableRule | ResourceManagerRule | Rule,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'context' is not null or undefined
            assertParamExists('updateRule', 'context', context);
            // verify required parameter 'nonEditableRuleResourceManagerRuleRule' is not null or undefined
            assertParamExists(
                'updateRule',
                'nonEditableRuleResourceManagerRuleRule',
                nonEditableRuleResourceManagerRuleRule
            );
            const localVarPath = `/rule/{context}`.replace(`{${'context'}}`, encodeURIComponent(String(context)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                nonEditableRuleResourceManagerRuleRule,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};

/**
 * RuleEditorControllerApi - functional programming interface
 * @export
 */
export const RuleEditorControllerApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = RuleEditorControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} context
         * @param {NonEditableRule | ResourceManagerRule | Rule} nonEditableRuleResourceManagerRuleRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRule(
            context: string,
            nonEditableRuleResourceManagerRuleRule: NonEditableRule | ResourceManagerRule | Rule,
            options?: AxiosRequestConfig
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonEditableRule | ResourceManagerRule | Rule>
        > {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRule(
                context,
                nonEditableRuleResourceManagerRuleRule,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} context
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRule(
            context: string,
            name: string,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRule(context, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnumNames(
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string> }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnumNames(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObjectSchemas(
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: ObjectSchema }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getObjectSchemas(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} context
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRule(
            context: string,
            name: string,
            options?: AxiosRequestConfig
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonEditableRule | ResourceManagerRule | Rule>
        > {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRule(context, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleConstants(
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RuleConstant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRuleConstants(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} context
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleFile(
            context: string,
            name: string,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRuleFile(context, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRules(
            context: string,
            options?: AxiosRequestConfig
        ): Promise<
            (
                axios?: AxiosInstance,
                basePath?: string
            ) => AxiosPromise<Array<NonEditableRule | ResourceManagerRule | Rule>>
        > {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRules(context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} context
         * @param {RuleTestDto} ruleTestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testRules(
            context: string,
            ruleTestDto: RuleTestDto,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRuleTestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testRules(context, ruleTestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} context
         * @param {NonEditableRule | ResourceManagerRule | Rule} nonEditableRuleResourceManagerRuleRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRule(
            context: string,
            nonEditableRuleResourceManagerRuleRule: NonEditableRule | ResourceManagerRule | Rule,
            options?: AxiosRequestConfig
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonEditableRule | ResourceManagerRule | Rule>
        > {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRule(
                context,
                nonEditableRuleResourceManagerRuleRule,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        }
    };
};

/**
 * RuleEditorControllerApi - factory interface
 * @export
 */
export const RuleEditorControllerApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) {
    const localVarFp = RuleEditorControllerApiFp(configuration);
    return {
        /**
         *
         * @param {RuleEditorControllerApiCreateRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRule(
            requestParameters: RuleEditorControllerApiCreateRuleRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<NonEditableRule | ResourceManagerRule | Rule> {
            return localVarFp
                .createRule(
                    requestParameters.context,
                    requestParameters.nonEditableRuleResourceManagerRuleRule,
                    options
                )
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RuleEditorControllerApiDeleteRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRule(
            requestParameters: RuleEditorControllerApiDeleteRuleRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<void> {
            return localVarFp
                .deleteRule(requestParameters.context, requestParameters.name, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnumNames(options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string> }> {
            return localVarFp.getEnumNames(options).then(request => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjectSchemas(options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: ObjectSchema }> {
            return localVarFp.getObjectSchemas(options).then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RuleEditorControllerApiGetRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRule(
            requestParameters: RuleEditorControllerApiGetRuleRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<NonEditableRule | ResourceManagerRule | Rule> {
            return localVarFp
                .getRule(requestParameters.context, requestParameters.name, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleConstants(options?: AxiosRequestConfig): AxiosPromise<Array<RuleConstant>> {
            return localVarFp.getRuleConstants(options).then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RuleEditorControllerApiGetRuleFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleFile(
            requestParameters: RuleEditorControllerApiGetRuleFileRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<any> {
            return localVarFp
                .getRuleFile(requestParameters.context, requestParameters.name, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RuleEditorControllerApiGetRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRules(
            requestParameters: RuleEditorControllerApiGetRulesRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<Array<NonEditableRule | ResourceManagerRule | Rule>> {
            return localVarFp.getRules(requestParameters.context, options).then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RuleEditorControllerApiTestRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testRules(
            requestParameters: RuleEditorControllerApiTestRulesRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<ResponseRuleTestDto> {
            return localVarFp
                .testRules(requestParameters.context, requestParameters.ruleTestDto, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RuleEditorControllerApiUpdateRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRule(
            requestParameters: RuleEditorControllerApiUpdateRuleRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<NonEditableRule | ResourceManagerRule | Rule> {
            return localVarFp
                .updateRule(
                    requestParameters.context,
                    requestParameters.nonEditableRuleResourceManagerRuleRule,
                    options
                )
                .then(request => request(axios, basePath));
        }
    };
};

/**
 * Request parameters for createRule operation in RuleEditorControllerApi.
 * @export
 * @interface RuleEditorControllerApiCreateRuleRequest
 */
export interface RuleEditorControllerApiCreateRuleRequest {
    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiCreateRule
     */
    readonly context: string;

    /**
     *
     * @type {NonEditableRule | ResourceManagerRule | Rule}
     * @memberof RuleEditorControllerApiCreateRule
     */
    readonly nonEditableRuleResourceManagerRuleRule: NonEditableRule | ResourceManagerRule | Rule;
}

/**
 * Request parameters for deleteRule operation in RuleEditorControllerApi.
 * @export
 * @interface RuleEditorControllerApiDeleteRuleRequest
 */
export interface RuleEditorControllerApiDeleteRuleRequest {
    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiDeleteRule
     */
    readonly context: string;

    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiDeleteRule
     */
    readonly name: string;
}

/**
 * Request parameters for getRule operation in RuleEditorControllerApi.
 * @export
 * @interface RuleEditorControllerApiGetRuleRequest
 */
export interface RuleEditorControllerApiGetRuleRequest {
    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiGetRule
     */
    readonly context: string;

    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiGetRule
     */
    readonly name: string;
}

/**
 * Request parameters for getRuleFile operation in RuleEditorControllerApi.
 * @export
 * @interface RuleEditorControllerApiGetRuleFileRequest
 */
export interface RuleEditorControllerApiGetRuleFileRequest {
    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiGetRuleFile
     */
    readonly context: string;

    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiGetRuleFile
     */
    readonly name: string;
}

/**
 * Request parameters for getRules operation in RuleEditorControllerApi.
 * @export
 * @interface RuleEditorControllerApiGetRulesRequest
 */
export interface RuleEditorControllerApiGetRulesRequest {
    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiGetRules
     */
    readonly context: string;
}

/**
 * Request parameters for testRules operation in RuleEditorControllerApi.
 * @export
 * @interface RuleEditorControllerApiTestRulesRequest
 */
export interface RuleEditorControllerApiTestRulesRequest {
    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiTestRules
     */
    readonly context: string;

    /**
     *
     * @type {RuleTestDto}
     * @memberof RuleEditorControllerApiTestRules
     */
    readonly ruleTestDto: RuleTestDto;
}

/**
 * Request parameters for updateRule operation in RuleEditorControllerApi.
 * @export
 * @interface RuleEditorControllerApiUpdateRuleRequest
 */
export interface RuleEditorControllerApiUpdateRuleRequest {
    /**
     *
     * @type {string}
     * @memberof RuleEditorControllerApiUpdateRule
     */
    readonly context: string;

    /**
     *
     * @type {NonEditableRule | ResourceManagerRule | Rule}
     * @memberof RuleEditorControllerApiUpdateRule
     */
    readonly nonEditableRuleResourceManagerRuleRule: NonEditableRule | ResourceManagerRule | Rule;
}

/**
 * RuleEditorControllerApi - object-oriented interface
 * @export
 * @class RuleEditorControllerApi
 * @extends {BaseAPI}
 */
export class RuleEditorControllerApi extends BaseAPI {
    /**
     *
     * @param {RuleEditorControllerApiCreateRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public createRule(requestParameters: RuleEditorControllerApiCreateRuleRequest, options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .createRule(requestParameters.context, requestParameters.nonEditableRuleResourceManagerRuleRule, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RuleEditorControllerApiDeleteRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public deleteRule(requestParameters: RuleEditorControllerApiDeleteRuleRequest, options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .deleteRule(requestParameters.context, requestParameters.name, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public getEnumNames(options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .getEnumNames(options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public getObjectSchemas(options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .getObjectSchemas(options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RuleEditorControllerApiGetRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public getRule(requestParameters: RuleEditorControllerApiGetRuleRequest, options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .getRule(requestParameters.context, requestParameters.name, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public getRuleConstants(options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .getRuleConstants(options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RuleEditorControllerApiGetRuleFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public getRuleFile(requestParameters: RuleEditorControllerApiGetRuleFileRequest, options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .getRuleFile(requestParameters.context, requestParameters.name, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RuleEditorControllerApiGetRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public getRules(requestParameters: RuleEditorControllerApiGetRulesRequest, options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .getRules(requestParameters.context, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RuleEditorControllerApiTestRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public testRules(requestParameters: RuleEditorControllerApiTestRulesRequest, options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .testRules(requestParameters.context, requestParameters.ruleTestDto, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RuleEditorControllerApiUpdateRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleEditorControllerApi
     */
    public updateRule(requestParameters: RuleEditorControllerApiUpdateRuleRequest, options?: AxiosRequestConfig) {
        return RuleEditorControllerApiFp(this.configuration)
            .updateRule(requestParameters.context, requestParameters.nonEditableRuleResourceManagerRuleRule, options)
            .then(request => request(this.axios, this.basePath));
    }
}

// custom hook generation here
export type PostCreateRuleResponse = AxiosResponse<NonEditableRule | ResourceManagerRule | Rule>;
export const KeyPostCreateRule = 'PostCreateRule';
export const useMutationPostCreateRule = (
    options?: UseMutationOptions<PostCreateRuleResponse, AxiosError, RuleEditorControllerApiCreateRuleRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<PostCreateRuleResponse, AxiosError, RuleEditorControllerApiCreateRuleRequest>(
        (args: RuleEditorControllerApiCreateRuleRequest) =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).createRule(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPostCreateRule = (
    args: RuleEditorControllerApiCreateRuleRequest,
    options?: UseQueryOptions<PostCreateRuleResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PostCreateRuleResponse, AxiosError>(
        [KeyPostCreateRule, args, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).createRule(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type DeleteDeleteRuleResponse = AxiosResponse<void>;
export const KeyDeleteDeleteRule = 'DeleteDeleteRule';
export const useMutationDeleteDeleteRule = (
    options?: UseMutationOptions<DeleteDeleteRuleResponse, AxiosError, RuleEditorControllerApiDeleteRuleRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<DeleteDeleteRuleResponse, AxiosError, RuleEditorControllerApiDeleteRuleRequest>(
        (args: RuleEditorControllerApiDeleteRuleRequest) =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).deleteRule(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryDeleteDeleteRule = (
    args: RuleEditorControllerApiDeleteRuleRequest,
    options?: UseQueryOptions<DeleteDeleteRuleResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<DeleteDeleteRuleResponse, AxiosError>(
        [KeyDeleteDeleteRule, args, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).deleteRule(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetEnumNamesResponse = AxiosResponse<{ [key: string]: Array<string> }>;
export const KeyGetGetEnumNames = 'GetGetEnumNames';
export const useMutationGetGetEnumNames = (
    options?: UseMutationOptions<GetGetEnumNamesResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetEnumNamesResponse, AxiosError>(
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getEnumNames(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetEnumNames = (
    options?: UseQueryOptions<GetGetEnumNamesResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetEnumNamesResponse, AxiosError>(
        [KeyGetGetEnumNames, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getEnumNames(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetObjectSchemasResponse = AxiosResponse<{ [key: string]: ObjectSchema }>;
export const KeyGetGetObjectSchemas = 'GetGetObjectSchemas';
export const useMutationGetGetObjectSchemas = (
    options?: UseMutationOptions<GetGetObjectSchemasResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetObjectSchemasResponse, AxiosError>(
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getObjectSchemas(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetObjectSchemas = (
    options?: UseQueryOptions<GetGetObjectSchemasResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetObjectSchemasResponse, AxiosError>(
        [KeyGetGetObjectSchemas, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getObjectSchemas(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetRuleResponse = AxiosResponse<NonEditableRule | ResourceManagerRule | Rule>;
export const KeyGetGetRule = 'GetGetRule';
export const useMutationGetGetRule = (
    options?: UseMutationOptions<GetGetRuleResponse, AxiosError, RuleEditorControllerApiGetRuleRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetRuleResponse, AxiosError, RuleEditorControllerApiGetRuleRequest>(
        (args: RuleEditorControllerApiGetRuleRequest) =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getRule(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetRule = (
    args: RuleEditorControllerApiGetRuleRequest,
    options?: UseQueryOptions<GetGetRuleResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetRuleResponse, AxiosError>(
        [KeyGetGetRule, args, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getRule(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetRuleConstantsResponse = AxiosResponse<Array<RuleConstant>>;
export const KeyGetGetRuleConstants = 'GetGetRuleConstants';
export const useMutationGetGetRuleConstants = (
    options?: UseMutationOptions<GetGetRuleConstantsResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetRuleConstantsResponse, AxiosError>(
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getRuleConstants(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetRuleConstants = (
    options?: UseQueryOptions<GetGetRuleConstantsResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetRuleConstantsResponse, AxiosError>(
        [KeyGetGetRuleConstants, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getRuleConstants(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetRuleFileResponse = AxiosResponse<any>;
export const KeyGetGetRuleFile = 'GetGetRuleFile';
export const useMutationGetGetRuleFile = (
    options?: UseMutationOptions<GetGetRuleFileResponse, AxiosError, RuleEditorControllerApiGetRuleFileRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetRuleFileResponse, AxiosError, RuleEditorControllerApiGetRuleFileRequest>(
        (args: RuleEditorControllerApiGetRuleFileRequest) =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getRuleFile(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetRuleFile = (
    args: RuleEditorControllerApiGetRuleFileRequest,
    options?: UseQueryOptions<GetGetRuleFileResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetRuleFileResponse, AxiosError>(
        [KeyGetGetRuleFile, args, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getRuleFile(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetRulesResponse = AxiosResponse<Array<NonEditableRule | ResourceManagerRule | Rule>>;
export const KeyGetGetRules = 'GetGetRules';
export const useMutationGetGetRules = (
    options?: UseMutationOptions<GetGetRulesResponse, AxiosError, RuleEditorControllerApiGetRulesRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetRulesResponse, AxiosError, RuleEditorControllerApiGetRulesRequest>(
        (args: RuleEditorControllerApiGetRulesRequest) =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getRules(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetRules = (
    args: RuleEditorControllerApiGetRulesRequest,
    options?: UseQueryOptions<GetGetRulesResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetRulesResponse, AxiosError>(
        [KeyGetGetRules, args, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getRules(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type PostTestRulesResponse = AxiosResponse<ResponseRuleTestDto>;
export const KeyPostTestRules = 'PostTestRules';
export const useMutationPostTestRules = (
    options?: UseMutationOptions<PostTestRulesResponse, AxiosError, RuleEditorControllerApiTestRulesRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<PostTestRulesResponse, AxiosError, RuleEditorControllerApiTestRulesRequest>(
        (args: RuleEditorControllerApiTestRulesRequest) =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).testRules(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPostTestRules = (
    args: RuleEditorControllerApiTestRulesRequest,
    options?: UseQueryOptions<PostTestRulesResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PostTestRulesResponse, AxiosError>(
        [KeyPostTestRules, args, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).testRules(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type PutUpdateRuleResponse = AxiosResponse<NonEditableRule | ResourceManagerRule | Rule>;
export const KeyPutUpdateRule = 'PutUpdateRule';
export const useMutationPutUpdateRule = (
    options?: UseMutationOptions<PutUpdateRuleResponse, AxiosError, RuleEditorControllerApiUpdateRuleRequest>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<PutUpdateRuleResponse, AxiosError, RuleEditorControllerApiUpdateRuleRequest>(
        (args: RuleEditorControllerApiUpdateRuleRequest) =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).updateRule(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPutUpdateRule = (
    args: RuleEditorControllerApiUpdateRuleRequest,
    options?: UseQueryOptions<PutUpdateRuleResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PutUpdateRuleResponse, AxiosError>(
        [KeyPutUpdateRule, args, options && options.queryKey, authQueryKey],
        () =>
            new RuleEditorControllerApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).updateRule(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
